<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
                <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/">Home</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Purchasing</a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/cpurchasing/index">Manage Purchase Order</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>View</h6>

            <div class="container-fluid">


              <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       
      
    
     
      
 
     </div>
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->

                <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      
     bottom>
    <template   #modal-title>
     
      <h3 >Confirm !</h3>

      
  
    </template>
    
    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm this item?</h5>
    </div>
    <hr>
    
    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>

  
  </b-modal>


                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       

                  <button  @click="Update()"  v-if="alldata.p_status==1" class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                                  <button  @click="Confimmodel()" v-if="alldata.p_status==1"   class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Confirm</button>
                              
                               <button   @click="generatePDF()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button>
                  <!-- v-if="alldata.p_status!=1" -->
            
                </div>

                <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                                <div class="d-flex justify-content-center" >
                                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                <div >


                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">

                  


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  table-responsive">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b> Id </b></td>
                           <td>{{ alldata.p_id }}</td> 
                          </tr>
                          <tr>
                            <td><b>PO Code.</b></td>
                           <td>{{ alldata.p_code }}</td> 
                          </tr>
                          <tr>
                            <td><b>Supplier Name</b></td>
                           <td>{{ alldata.relatedToSupplier.sup_name }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Stock Order #</b></td>
                           <td>{{ alldata.stock_order }}</td> 
                          </tr>
                          <tr>
                            <td><b>Purchasing Date </b></td>
                           <td>{{ alldata.p_purchasing_date }}</td> 
                          </tr>
                          
                          <tr>
                            <td><b>Follow up Date </b></td>
                           <td>{{ alldata.p_followup_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Due Date</b></td>
                           <td>{{ alldata.p_due_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Upload PO </b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Currency</b></td>
                           <td>{{ alldata.relatedToCurrency.name }}</td> 
                          </tr>
                          <tr>
                            <td><b>Mode of Shipment</b></td>
                           <td>{{ alldata.relatedToShipMode.mode }}</td> 
                          </tr>
                          <tr>
                            <td><b>Remarks</b></td>
                           <td>{{ alldata.p_remarks }}</td> 
                          </tr>
                          <tr>
                            <td><b>Status</b></td>
                           <td>{{ alldata.relatedToStatus.status }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created Date</b></td>
                           <td>{{ alldata.p_created_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Username</b></td>
                           <td>{{ alldata.relatedToUser.username }}</td> 
                          </tr>
                          
                         
                           
                        </tbody>
                 
                 
                      </table>

                      </div>
                      </div>


                      <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Purchasing Items</b></h6>

                        <div class="table-responsive">
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless  ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Product Code</th>
                              <th>Product Description</th>
                              <th class="text_right">Requested Qty</th>
                              <th class="text_right">GRN Qty</th>
                              <th class="text_right">Unit Price</th>
                              <th class="text_right">Total	</th>
                              <th class="text_right">status</th>
                           
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(detail, index) in details" :key="detail.id">
                              <td>{{ index+1 }}</td>
                              <td>{{detail.P_code}} </td>
                              <td>{{detail.P_description}} </td>
                              <td class="text_right">{{ detail.p_qty }}</td>
                              <td class="text_right">{{ detail.grn_qty }}</td>
                              <td class="text_right">{{ detail.p_product_price }}</td>
                              <td class="text_right">{{ detail.p_total }}</td>
                              <td class="text_right">{{ detail.status }}</td>
                   
                           
                              </tr>
                              <tr style="border-top: 2px solid black; " >
                              <td></td>
                           
                              <td></td>
                              <th>Total :</th>
                              <td class="text_right">{{ total.total_qty }}</td>
                              <td></td>
                             
                              <th class="text_right"></th>
                              <th class="text_right">{{ total.total_line_amount }}</th>
                              <th class="text_right"></th>
                            
                          
                              </tr>
                             
                            </tbody>

                          </table>
                        </div>

                        </div>
                    </div>



                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Payment Method</b></h6>

                          <div class="table-responsive">
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Payment Method</th>
                              <th>Payment Due Date</th>
                            
                              </tr>
                            </thead>
                            <tbody>
                                <tr  v-for="(pay_det, index) in pay_dets" :key="pay_det.id">
                                    <td>{{ index+1 }}</td>
                              <td>{{ pay_det.p_method }}</td>
                              <td>{{ pay_det.p_due_date }}</td>
                            
                              </tr>
                            </tbody>

                          </table>

</div>  
                        </div>
                    </div>






                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>

                           <div class="table-responsive">
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless  ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>

                          </table>
</div>

                        </div>
                    </div>



                    <div class="card custom_bdr_rds shadow p-2">
              <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>CRM Notes</b></h6>

               <div class="table-responsive">  
              <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                  <thead class="background_color2" >
                    <tr class="custom-label2">
                    <th>#</th>
                    <th>Comment</th>
                    <th>Job Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Follow up Date	</th>
                    <th>Follow up by	</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="(mservicelog, index) in mservicelogs" :key="mservicelog.idServicelog">
                    <td>{{index+1}}</td>
                    <td>{{ mservicelog.comments }}</td>
                    <td>{{ mservicelog.job_type }}</td>
                    <td>{{ mservicelog.created_date }}</td>
                    <td>{{ mservicelog.relatedToUser.username }}</td>
                    <td>{{ mservicelog.followup_date }}</td>
                    <td>{{ mservicelog.relatedToFollowupby.username }}</td>
                  
                    
                    </tr>
                  </tbody>

                </table>
</div>

          <br>
              

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3" v-model="crm.comments"  style="font-size: small;" class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select class="form-select " v-model="crm.job_type">
                              <option  selected>Select....</option>
                              <option >Vehicle Sales</option>
                              <option  >Spare Parts Sales</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input v-model="crm.followup_date" type="date"  style="font-size: small;" class="form-control" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input v-model="username"  style="font-size: small;" class="form-control" disabled>
                    </div>
                  </div>


                </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                    <button @click="crmCreate()"  class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Save</button>
                </div>
                </div>

            </div>
        </div>







   

<br><br>





                




                </div>
                </div>
              </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import jsPDF from 'jspdf';
   import 'jspdf-autotable';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSquatation()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            username:authService.isUsername(),
            total:{},
            alldata:{},
            category:{},
            brand:{},
            supplier:{},
            status:{},
            user:{},
            crm:{},
            all_code:{},
            details:[],
            pay_dets:[],
            mservicelogs:[],
            trans:[],
            infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },
           
          }
    
        },
        components :{
         
            ContentFooter,
            TopNavbar,
           
        },

        methods : {



//           generatePDF() {
//   const doc = new jsPDF();

//   // Function to add page borders
//   function addPageBorders(doc) {
//     const pageWidth = doc.internal.pageSize.width;
//     const pageHeight = doc.internal.pageSize.height;

//     doc.setDrawColor(71, 144, 255); // Border color
//     doc.setLineWidth(1); // Border width

//     // Draw borders
//     doc.line(5, 5, pageWidth - 5, 5); // Top
//     doc.line(5, pageHeight - 5, pageWidth - 5, pageHeight - 5); // Bottom
//     doc.line(5, 5, 5, pageHeight - 5); // Left
//     doc.line(pageWidth - 5, 5, pageWidth - 5, pageHeight - 5); // Right
//   }

//   // Add image to the PDF
//   const img = new Image();
//   img.src = '/img/envision.jpg';
//   img.onload = () => {
//     const imageWidth = doc.internal.pageSize.getWidth() / 2;
//     const imageHeight = imageWidth * (img.height / img.width);
//     doc.addImage(img, 'JPEG', 10, 10, imageWidth, imageHeight);

//     // Add text content
//     doc.setFontSize(18);
//     doc.setFont('Helvetica', 'bold');
//     doc.text('Component PO', 105, 30, null, null, 'center');
    
//     doc.setFontSize(12);
//     doc.text('Envision System', 10, 50);

//     doc.setFont('Helvetica', 'normal');
//     doc.setFontSize(8);
//     doc.text('No 08, Rodrigo Mawatha, Nawala Road, Rajagiriya, Colombo 08, Sri Lanka', 10, 60);

//     doc.setFontSize(10);
//     doc.setFont('Helvetica', 'bold');
//     doc.text('Sales Order To:', 85, 70);
//     doc.setFontSize(8);
//     doc.text(this.alldata.relatedToSupplier.sup_name, 85, 75);
//     doc.text(this.alldata.relatedToSupplier.sup_address_1, 85, 80);
//     doc.text(this.alldata.relatedToSupplier.sup_address_2, 85, 85);
//     doc.text(this.alldata.relatedToSupplier.sup_address_3, 85, 90);

//     // Table data
//     const tableData = [
//       ['No', 'Product Code', 'Product Description', 'Requested Qty', 'GRN Qty', 'Unit Price', 'Total'],
//     ];

//     this.details.forEach(detail => {
//       tableData.push([
//         detail.no,
//         detail.P_code,
//         detail.P_description,
//         detail.p_qty,
//         detail.grn_qty,
//         detail.p_product_price,
//         detail.p_total,
//       ]);
//     });

//     // Generate table
//     doc.autoTable({
//       startY: 100,
//       head: [tableData[0]],
//       body: tableData.slice(1),
//       styles: { fontSize: 8, font: 'Helvetica' },
//       didDrawPage: function () {
//         addPageBorders(doc);
//       },
//     });

//     // Add footer
//     const tableBottomY = doc.lastAutoTable.finalY + 10;
//     doc.setFontSize(10);
//     doc.text('Total: ' + this.total.total_line_amount, 200, tableBottomY, null, null, 'right');

//     doc.setFontSize(8);
//     doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY + 10);
//     doc.text('* Settlement should be made within 5 days.', 10, tableBottomY + 15);

//     // Download the PDF
//     doc.save('PurchaseOrder.pdf');
//   };
// },

// generatePDF2() {
//   const doc = new jsPDF();

//   // Function to add page borders
//     function addPageBorders(doc) {
//     const pageWidth = doc.internal.pageSize.width;
//     const pageHeight = doc.internal.pageSize.height;

//     doc.setDrawColor(71, 144, 255); // Border color
//     doc.setLineWidth(1); // Border width

//     // Draw borders
//     doc.line(5, 5, pageWidth - 5, 5); // Top
//     doc.line(5, pageHeight - 5, pageWidth - 5, pageHeight - 5); // Bottom
//     doc.line(5, 5, 5, pageHeight - 5); // Left
//     doc.line(pageWidth - 5, 5, pageWidth - 5, pageHeight - 5); // Right
//   }

//   // Add image to the PDF
//   const img = new Image();
//   img.src = '/img/envision.jpg';
//   img.onload = () => {
//     const imageWidth = doc.internal.pageSize.getWidth() / 2;
//     const imageHeight = imageWidth * (img.height / img.width);
//     doc.addImage(img, 'JPEG', 5, 5, imageWidth, imageHeight);

//     // Add text content
//     doc.setFontSize(18);
//     doc.setFont('Helvetica', 'bold');
//     doc.text('Component PO', 105, 30, null, null, 'center');
    
//     doc.setFontSize(12);
//     doc.text('Envision System', 10, 50);

//     doc.setFont('Helvetica', 'normal');
//     doc.setFontSize(8);
//     doc.text('No 08, Rodrigo Mawatha, Nawala Road, Rajagiriya, Colombo 08, Sri Lanka', 10, 60);

//     doc.setFontSize(10);
//     doc.setFont('Helvetica', 'bold');
//     doc.text('Sales Order To:', 85, 70);
//     doc.setFontSize(8);
//     doc.text(this.alldata.relatedToSupplier.sup_name, 85, 75);
//     doc.text(this.alldata.relatedToSupplier.sup_address_1, 85, 80);
//     doc.text(this.alldata.relatedToSupplier.sup_address_2, 85, 85);
//     doc.text(this.alldata.relatedToSupplier.sup_address_3, 85, 90);

//     // Table data
//     const tableData = [
//       ['No', 'Product Code', 'Product Description', 'Requested Qty', 'GRN Qty', 'Unit Price', 'Total'],
//     ];

//     this.details.forEach(detail => {
//       tableData.push([
//         detail.no,
//         detail.P_code,
//         detail.P_description,
//         detail.p_qty,
//         detail.grn_qty,
//         detail.p_product_price,
//         detail.p_total,
//       ]);
//     });

//     // Generate table
//     doc.autoTable({
//       startY: 100,
//       head: [tableData[0]],
//       body: tableData.slice(1),
//       styles: { fontSize: 8, font: 'Helvetica' },
//       didDrawPage: function () {
//         addPageBorders(doc);
//       },
//     });

//     // Add footer
//     const tableBottomY = doc.lastAutoTable.finalY + 10;
//     doc.setFontSize(10);
//     doc.text('Total: ' + this.total.total_line_amount, 200, tableBottomY, null, null, 'right');

//     doc.setFontSize(8);
//     doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY + 10);
//     doc.text('* Settlement should be made within 5 days.', 10, tableBottomY + 15);

//     // Open the PDF in a new tab
//     const blob = doc.output('blob');
//     const url = URL.createObjectURL(blob);
//     window.open(url, '_blank');
//   };
// },


          generatePDF() {
    
    const doc = new jsPDF();

    function addPageBorders(doc) {
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  // Set the border style
  doc.setDrawColor(71, 144, 255); // Black color
  doc.setLineWidth(15); // Border width

  // Draw a line at the top of the page
  doc.line(0, 0, pageWidth, 0);
  // Draw a line at the bottom of the page
  doc.line(0, pageHeight, pageWidth, pageHeight);
}
   // Update this with your image URL or file path
   
    var img = new Image()
  img.src = '/img/evenware-logo.jpg'
  img.onload = () => {
  const imageWidth = doc.internal.pageSize.getWidth() - 500; // Adjust 20 if you need margins
const imageHeight = (imageWidth * 4) / 4; // Assuming the aspect ratio is 4:3, adjust as needed

doc.addImage(img, 'jpg', 10, 13, imageWidth, imageHeight);
doc.setFontSize(18);
doc.setFont('Helvetica', 'bold');
doc.text('Component PO', 105, 30, null, null, 'center');
doc.setFontSize(12);

doc.text('Envision System', 10, 45, null, null);

doc.setFont('Helvetica', 'normal');
doc.setFontSize(8);
doc.text('No 08, Rodrigo Mawatha,', 10, 48, null, null);
doc.text('Nawala Road,', 10, 51, null, null);
doc.text('Rajagiriya,', 10, 54, null, null);
doc.text('Colombo 08,', 10, 57, null, null);
doc.text('Sri Lanka', 10, 60, null, null);
doc.text('Tel : 0112 806 776-9,', 10, 63, null, null);
doc.text('Web : colombo@cmc.slt.lk ,', 10, 66, null, null);


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Sales Order To:', 85, 45, null, null);
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
const supplierName = this.alldata.relatedToSupplier.sup_name;
const sup_address_1 = this.alldata.relatedToSupplier.sup_address_1;
const sup_address_2 = this.alldata.relatedToSupplier.sup_address_2;
const sup_address_3 = this.alldata.relatedToSupplier.sup_address_3;

doc.text(supplierName, 85, 48);
doc.text(sup_address_1, 85, 51, null, null);
doc.text(sup_address_2, 85, 54, null, null);
doc.text(sup_address_3, 85, 57, null, null);






doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('PO Code:', 200, 45, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.alldata.p_code, 200, 49, null, null, 'right');


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Supplier:', 200, 53, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(supplierName, 200, 56, null, null, 'right');
let stock_order = ''; // Use `let` for variables that may change

if (this.alldata.stock_order == null) {
  stock_order = ''; // Assign an empty string if stock_order is empty
} else {
  stock_order = this.alldata.stock_order; // Assign the value from alldata
}


doc.setFont('Helvetica', 'bold');
doc.text('Stock Order:', 200, 60, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(stock_order, 200, 63, null, null, 'right');
doc.setFontSize(10);






doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Purchasing Date:', 200, 67, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.alldata.p_purchasing_date, 200, 70, null, null, 'right');

const tableData = [
      ['No', 'Product Code', 'Product Description', 'Requested Qty', 'GRN Qty', 'Unit Price	', 'Total']
  ];
  

  this.details.forEach(detail => {
      tableData.push([
          detail.no,
          detail.P_code,
          detail.P_description,
          { content: detail.p_qty, styles: { halign: 'right' } },
          { content: detail.grn_qty, styles: { halign: 'right' } },
          { content: detail.p_product_price, styles: { halign: 'right' } },
         
       
          { content: detail.p_total, styles: { halign: 'right' } },
         
         
        
      ]);
  });

      // Add table to the PDF
      doc.autoTable({
            startY: 85, // Y position to start the table
            head: [tableData[0]], // Table header
            body: tableData.slice(1),
            addPageContent: function(data) {
        addPageBorders(doc); // Call the function to add page borders
    },
    styles: {
        font: 'Helvetica',
        fontSize:8,
    },
          // Table data excluding header
      });

      
      const tableBottomY = doc.lastAutoTable.finalY;

      doc.setFontSize(10);
      doc.setFont('Helvetica', 'bold');
      doc.text('Total: '+this.total.total_line_amount, 195, tableBottomY+10, null, null, 'right');

     

      doc.setFontSize(9);
        doc.setFont('Helvetica', 'normal');
      doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY+50, null, null);
      doc.text('* Settlement should be made within 5 days', 10, tableBottomY+55, null, null);
      doc.text('* Any complaints should be informed within 3 days after receiving the goods.', 10, tableBottomY+60, null, null);
      doc.text('* Complaints after 3 days will not be accepted under any circumstances.', 10, tableBottomY+65, null, null);
      doc.text('* Bank Details : Commercial Bank (7056), Old Moor Street Branch (017), A/C No. 100 039 2638. ', 10, tableBottomY+70, null, null);
      doc.text('* The above Invoice is inclusive of all taxes.', 10, tableBottomY+75, null, null);
      

      // doc.output('dataurlnewwindow');
   
      
      const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  },
    


          
          async Update(){
        this.$router.push('/cpurchasing/update?id='+this.id);
      },
      async Confimmodel(){
        this.infoModal1.content = this.id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },

      async Creategin(){
        this.$router.push('/gin/createsogin?id='+this.id);
      },


      async crmCreate() {
       
    
       try {
         const { data} = await  axios.post('/ppurchasing/crmcreate?id='+this.id,{crm:this.crm,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
          
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },



            async loadSquatation() {
     
      
      try {
        const { data} = await  axios.get('/ppurchasing/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.alldata = data.model;
         this.details = data.details;
         this.pay_dets = data.pay_dets;
         this.total = data.total;
         this.mservicelogs =data.mservicelogs;
        
       
        
      } catch (error) {
        console.log(error.response);
      }
    },

    async Confirm(id) {
       
    
       try {
         const { data} = await  axios.get('/ppurchasing/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>